import React from "react"
import Button from "../Button/Button"

const LatestPostsThree = ({ title, introduction }) => {
  return (
    <div className="section">
      <div className="container container__tight">
        {title || introduction ? (
          <div className="intro__area">
            {title && <h2>{title}</h2>}
            {introduction && <p>{introduction}</p>}
          </div>
        ) : null}

        <div className="learn__more">
          <Button
            text="Get in touch"
            href="mailto:dynamicwebpartners@gmail.com"
          />
        </div>
      </div>
    </div>
  )
}

export default LatestPostsThree
